import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';

import type { DesignSystemCardSize } from '../../theme/design-system/types';
import type { TypographyProps } from '../Typography/Typography';
import { Typography } from '../Typography/Typography';
import { useSlotContext } from '../../utils/useSlotContext';
import { DEFAULT_CARD_SIZE } from './Card.constants';

type CardTitleProps = {
    children: ReactNode;
    sx?: SxProps<Theme>;
};

const titleVariantMap: Record<
    DesignSystemCardSize,
    TypographyProps['variant']
> = {
    xs: 'sm',
    sm: 'md',
    md: 'lg',
};

export const CardTitle = (props: CardTitleProps) => {
    const { size = DEFAULT_CARD_SIZE } = useSlotContext(props, 'card');
    const variant = titleVariantMap[size];

    return (
        <Typography variant={variant} fontWeight="semibold" sx={props.sx}>
            {props.children}
        </Typography>
    );
};
